// SPV Pool v1.0 PR 6 — Section B. The waterfall application table.
// Payment System v3.0 PR 3c (design spec §6.4): priority names are now
// sourced from the API-served `row.name` field — the cash-flow endpoint
// is the source of truth — rather than the deprecated frontend
// `WATERFALL_PRIORITY_LABELS` mirror, which is removed by this PR.

import { Card } from "@/design-system/components/ui";
import { Table, THead, TBody, TR, TH, TD } from "@/design-system/components/ui";
import { formatCurrency, formatPct } from "../../../shared/format";
import type { CashFlowWaterfallDto } from "@/types/spvPool";

interface WaterfallApplicationTableProps {
  waterfall: CashFlowWaterfallDto;
}

export function WaterfallApplicationTable({
  waterfall,
}: WaterfallApplicationTableProps) {
  const rows = [...waterfall.rows].sort((a, b) => a.priority - b.priority);

  return (
    <Card>
      <h3 className="font-display font-bold text-h3 m-0 mb-space-3">
        Waterfall Application
      </h3>
      {rows.length === 0 ? (
        <p className="text-small text-gray-mid italic m-0">
          No waterfall postings for this period.
        </p>
      ) : (
        <Table>
          <THead>
            <TR>
              <TH>Priority #</TH>
              <TH>Priority Name</TH>
              <TH>Period Amount ($)</TH>
              <TH>% of Inflows</TH>
            </TR>
          </THead>
          <TBody>
            {rows.map((row) => (
              <TR key={row.priority}>
                <TD>{row.priority}</TD>
                <TD>{row.name}</TD>
                <TD>{formatCurrency(row.amount)}</TD>
                <TD>{formatPct(row.pctOfInflows)}</TD>
              </TR>
            ))}
            <TR>
              <TD />
              <TD className="font-semibold">Total</TD>
              <TD className="font-semibold">
                {formatCurrency(waterfall.totalAmount)}
              </TD>
              <TD />
            </TR>
          </TBody>
        </Table>
      )}
    </Card>
  );
}
